var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dialog',{ref:"layoutDialog",attrs:{"title":"Privacy Policy","subtitle":"SPONTAY, LLC"}},[_c('div',{attrs:{"id":"policies","name":"termly-embed","data-type":"iframe","data-id":"818a126e-da1e-45b6-aeeb-c63618027620"}})])}
var staticRenderFns = []

export { render, staticRenderFns }